import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';

import { FaqItem } from '../../../model/faq-items.model';
import { FaqItemAdapter } from '../faq-item.adapter';

@Injectable({ providedIn: 'root' })
export class OccFaqItemAdapter implements FaqItemAdapter {
  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService
  ) {}

  getDetails(
    faqItemCode: string,
    isUserLoggedIn: boolean
  ): Observable<FaqItem> {
    const url = this.occEndpoints.buildUrl('faqItemDetails', {
      urlParams: {
        userId: isUserLoggedIn ? 'current' : 'anonymous',
        faqItemCode,
      },
    });

    return this.http.get<FaqItem>(url);
  }
}
